import WrapperAccordion from '../general/WrapperAccordion'
import FormProgramOverviewSubmenus from '../forms/FormProgramOverviewSubmenus';

const DisplayProgramOverviewMenu = ({transId, type, cinema, activeSelection, collapseActiveSelection, attributes, programOverviewSubmenus, onUpdateProgramOverviewSubmenus}) => {
    if(!cinema) {
        return ''
    }

    const selectionActiveClass = activeSelection === type ? "accordion-item-open" : "accordion-item-close"

    return (
        <WrapperAccordion
            selectionActiveClass={selectionActiveClass}
            transId={transId}
            className={type  + ' single-section'}
            collapseActiveSelection={collapseActiveSelection}
        >
            {programOverviewSubmenus && <FormProgramOverviewSubmenus 
                movies={{}}
                attributes={attributes.global}
                cinemaAttributes= {attributes[cinema.pk]}
                programOverviewSubmenus={programOverviewSubmenus}
                onUpdateProgramOverviewSubmenus={onUpdateProgramOverviewSubmenus}
            />}
        </WrapperAccordion>
    )
}

export default DisplayProgramOverviewMenu